























import { Component, Vue, Ref } from 'vue-property-decorator'
import TitleBase from '@/components/atoms/TitleBase.vue'
import TitleTextBase from '@/components/atoms/TitleTextBase.vue'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ListItemBox from '@/components/organisms/ListItemBox.vue'
import ModalTeacherInput, { ModalParams } from '@/components/organisms/ModalTeacherInput.vue'
import { TEACHER_SETTING_TEXT } from '@/constants'

@Component({
  components: {
    TitleBase,
    TitleTextBase,
    ColoredBox,
    ButtonBase,
    ListItemBox,
    ModalTeacherInput,
  },
})
export default class Attribute extends Vue {
  private breadcrumbs = [
    { text: TEACHER_SETTING_TEXT, href: '/teacher/setting/top' },
    { text: 'グループ', active: true },
  ]

  private attributeDatas: {
    id: number
    name: string
  }[] = []

  @Ref() modalTeacherInput!: ModalTeacherInput

  private modalInfo: ModalParams = {}

  private showModalInputAdd(): void {
    this.modalInfo = {
      //- 1 Mod Start 20221129
      //- title: '任意属性追加',
      title: 'グループ追加',
      //- 1 Mod End 20221129
      buttonName: '追加',
      value: '',
      maxLength: 20,
      onClick: this.create,
    }
    this.modalTeacherInput.show()
  }

  private showModalInputEdit(index: number): void {
    this.modalInfo = {
      id: this.attributeDatas[index].id,
      //- 1 Mod Start 20221129
      //- title: '任意属性編集',
      title: 'グループ編集',
      //- 1 Mod End 20221129
      buttonName: '保存',
      value: this.attributeDatas[index].name,
      maxLength: 20,
      onClick: this.update,
    }
    this.modalTeacherInput.show()
  }

  private branchId = Vue.prototype.$cookies.get('dataGdls').branchId

  private mounted() {
    this.loadDatas()
  }

  private async loadDatas() {
    await Vue.prototype.$http.httpWithToken.get(`/v3/student_groups?branchId=${this.branchId}`).then((res: any) => {
      this.attributeDatas = res.data.studentGroups.map((userAttribute: { id: number; title: string }) => {
        return {
          id: userAttribute.id,
          name: userAttribute.title,
        }
      })
    })
  }

  private async update(): Promise<void> {
    this.modalTeacherInput.hide()
    await Vue.prototype.$http.httpWithToken
      .put(`/v3/student_groups/${this.modalInfo.id}`, { title: this.modalInfo.value })
      .then(() => {
        this.loadDatas()
      })
      .catch((error: any) => {
        if (error.response.data.status === 409) {
          alert('グループが重複しているため登録できません。')
        } else if (error.response.data.status === 404) {
          alert('データが見つかりません。ページを更新してお確かめください。')
        }
      })
  }

  private async create(): Promise<void> {
    this.modalTeacherInput.hide()
    await Vue.prototype.$http.httpWithToken
      .post('/v3/student_groups', { branchId: this.branchId, title: this.modalInfo.value })
      .then(() => {
        this.loadDatas()
      })
      .catch((error: any) => {
        if (error.response.data.status === 409) {
          alert('グループが重複しているため登録できません。')
        }
      })
  }

  private async destroy(id: number): Promise<void> {
    if (!confirm('削除しますか？')) return

    await Vue.prototype.$http.httpWithToken
      .delete(`/v3/student_groups/${id}`)
      .then(() => {
        this.loadDatas()
      })
      .catch((error: any) => {
        if (error.response.data.status === 422) {
          alert('生徒が存在しているため削除できません。')
        } else if (error.response.data.status === 404) {
          alert('データが見つかりません。ページを更新してお確かめください。')
        }
      })
  }
}
